import { useMemo } from "react";
import GetSources from "./get-sources";

const useSourcesData = () => {
    const { data, isLoading, error, isError } = GetSources();

    const processedData = useMemo(() => {
        if (!data?.data?.data) {
            return {
                sources: [],
                channels: [],
                sourceChannelMap: {},
                isLoaded: false
            };
        }

        return {
            sources: data.data.data.sources || [],
            channels: data.data.data.channels || [],
            sourceChannelMap: data.data.data.sourceChannelMap || {},
            isLoaded: true
        };
    }, [data]);

    // Helper function to get channels for a specific source
    const getSourcesForChannels = useMemo(() => {
        return (channel) => {
            return processedData.sourceChannelMap[channel] || [];
        };
    }, [processedData.sourceChannelMap]);

    // Helper function to get all source-channel combinations
    const getSourceChannelOptions = useMemo(() => {
        const options = [];
        processedData.channels.forEach(channel => {
            const sources = processedData.sourceChannelMap[channel] || [];
            sources.forEach(source => {
                options.push({
                    source,
                    channel,
                    label: `${channel} - ${source}`,
                    value: `${channel}_${source}`
                });
            });
        });
        return options;
    }, [processedData.sources, processedData.sourceChannelMap]);

    return {
        ...processedData,
        isLoading,
        error,
        isError,
        getSourcesForChannels,
        getSourceChannelOptions
    };
};

export default useSourcesData;
